import aiCostsFiltersSignal from '@UI/Pages/Administration/AiCosts/Filters/Signals/aiCostsFiltersSignal';
import useAiCostSummary from '@UI/Pages/Administration/AiCosts/Hooks/useAiCostSummary';
import type AiCostSummaryView from '@UI/Store/AiCosts/Views/AiCostSummaryView';
import { useSignalValue } from '@verclam/pulsar';

type Result = {
	/** The summary of the period and filters of the screen: source of the Total row. */
	readonly total: AiCostSummaryView | null;
	/** The summary of the period alone, whatever the filters: the average that deviations are measured against. */
	readonly reference: AiCostSummaryView | null;
};

/** Reads both summaries; the reference one (period alone) is only fetched while a scope filter is set. */
const useAiCostSummaries = (accountId: number): Result => {
	const filters = useSignalValue(aiCostsFiltersSignal);

	const { data: total } = useAiCostSummary(accountId, filters.summaryQueryParams, true);
	const { data: reference } = useAiCostSummary(accountId, filters.periodQueryParams, filters.hasScope);

	return {
		total: total !== null && total.accountId === accountId ? total : null,
		reference: reference !== null && reference.accountId === accountId ? reference : null,
	};
};

export default useAiCostSummaries;
